/* eslint-disable max-len */
/* eslint-disable no-console */
import { map, uniqBy } from 'lodash';
import { setmyUniqElementModels_ud } from '../userData';
// eslint-disable-next-line
export let myUniqElementModels; // eslint-disable-next-line
export let myUniqElementModels_num; // eslint-disable-next-line
let sharedEm; // eslint-disable-next-line
let sharedEm_no;
let allElementModelsObj; // eslint-disable-next-line
export let isElementAccess = true;

const elementModelDirectory = {};

function processInput(input) {
  const result = [];

  for (let i = 0; i < input.length; i += 1) {
    const item = input[i];

    const processedItem = item.replace(/[-, _()/.%]/g, '');
    result.push(processedItem);
  }

  return result;
};

export const ro_elem_access = (elements_dict, users_dict) => { // new ro ele. accs. logic

  // calculate user_passcode
  let user_passcode = [];

  const curr_user_email = sessionStorage.getItem('user_email');
  // const curr_user_email = 'sheril.mathew@veolia.com';

  const allUserEmails = Object.keys(users_dict);

  if (allUserEmails.includes(curr_user_email)) { // check if user not added in elements_user_details table
    user_passcode = users_dict[curr_user_email] ?
      (users_dict[curr_user_email].F_M.split(',').map(item => Number(item)) || [0]) : [0];

    if (!user_passcode.includes(0)) {
      user_passcode.unshift(0);   // add 0 in user_passcode array
    }
  }
  else {
    user_passcode = [0];
  }
  const arrData = map(elements_dict, (row) => row);
  allElementModelsObj = uniqBy(arrData, 'strModel');
  // by Abhishek on 31-Jan for makeing a directory for easy element check and refrenece
  allElementModelsObj.forEach((item) => {
    const key = processInput([item.strModel]);
    // key
    elementModelDirectory[key] = {
      'elementModelName': item.strModel,
      'elementModelNumber': item.nElementNumber
    };
  });

  // By Abhishek on 15-4-25
  // checks if at least one element in the temp array satisfies a condition.
  //  The condition here is user_passcode.includes(code),
  //  which checks if the user_passcode array contains the current code from the temp array.

  // This code filters the `allElementModelsObj` array to create a new array, `myUniqElementModelsObj`,
  // containing only the elements that have a `passWordCode` that includes at least one of the values in the `user_passcode` array.
  const myUniqElementModelsObj = allElementModelsObj.filter((item) => {
    // 1. Convert the `passWordCode` string to an array of numbers:
    //   - `item.passWordCode.split(',')`: Splits the `passWordCode` string (e.g., "1,2,3,4,5,6,10") into an array of strings (e.g., ["1", "2", "3", "4", "5", "6", "10"]).
    //   - `.map(Number)`: Converts each string element in the array to a number (e.g., [1, 2, 3, 4, 5, 6, 10]).
    const temp = item.passWordCode.split(',').map(Number);
    // 2. Check if any of the numbers in the `temp` array are present in the `user_passcode` array:
    //   - `temp.some(code => user_passcode.includes(code))`:  The `some()` method tests whether at least one element in the `temp` array passes the test implemented by the provided function.
    //   - `code => user_passcode.includes(code)`: This is the test function. For each `code` in the `temp` array, it checks if the `user_passcode` array `includes` that `code`.
    //   - If `user_passcode` includes the current `code`, the test function returns `true`, and `some()` immediately returns `true`.
    //   - If none of the codes in `temp` are found in `user_passcode`, `some()` returns `false`.
    return temp.some(code => user_passcode.includes(code));
  });

  // myUniqElementModelsObj = processInput(myUniqElementModelsObj);
  // by Abhishek : 22-Jan
  const uniqElementModel_no = myUniqElementModelsObj;
  // allElementModelsObj.filter((item) => {
  //   // Iterate through each passcode in the user_passcode array.
  //   for (let i = 0; i < user_passcode.length; i += 1) {
  //     // Check if the current user passcode is present as a substring within the item's passWordCode.
  //     // Note: This uses template literals to convert user_passcode[i] to a string for the includes() method.
  //     if (item.passWordCode.includes(`${user_passcode[i]}`))
  //       // If the user passcode is found, return the current item.
  //       // Returning item here means that the filter condition is met, and the item will be included in the resulting array.
  //       return item;
  //   }
  // });
  myUniqElementModels = myUniqElementModelsObj.map(item => item.strModel);
  // setmyUniqElementModels_ud(myUniqElementModels);
  myUniqElementModels = processInput(myUniqElementModels);
  // GB-2659 -start
  // In RO form, if the users don't have access to any element model under a given element group,
  // then that element group should be hidden. Eg: NF PA--> Seawater NF
  setmyUniqElementModels_ud(myUniqElementModels);
  // GB-2659 -Ends
  myUniqElementModels_num = uniqElementModel_no.map(item => item.nElementNumber);
  myUniqElementModels_num.sort((a, b) => a - b);
};

// Note : we are checking the elememt-model name and num bott because
// Name  : parse the name by removing special char
// num : to check the unique elemnet model no. access
export const ro_elem_shared_access = (formData_ro = '') => {

  if (formData_ro === '' || Object.keys(formData_ro).length === 0)
    return true;
  const ro_pass = Object.values(formData_ro);
  const elmodel = ro_pass.map(item => {
    if (item['grid-data']) {
      const cur_ro_em = Object.values(item['grid-data'].map(o => o.elementModel));
      return cur_ro_em;
    }
  });

  const elmodel_no = ro_pass.map(item => {
    if (item['grid-data']) {
      const cur_ro_em = Object.values(item['grid-data'].map(o => o.elementModelNumber));
      return cur_ro_em;
    }
  });
  let sharedElmodel = [];
  const sharedElmodel_no = [];
  for (let i = 0; i < elmodel.length; i += 1) {
    for (let j = 0; j < 8; j += 1) {
      if (elmodel[i][j] === '' || elmodel[i][j] === ' ') // eslint-disable-next-line
        continue;
      else {
        sharedElmodel.push(elmodel[i][j]);
        sharedElmodel_no.push(elmodel_no[i][j] ? elmodel_no[i][j] : '');
      }
    }
  }

  const sharedElmodel_temp = sharedElmodel.filter(item => item != null);
  sharedElmodel = processInput(sharedElmodel_temp);
  sharedEm = sharedElmodel;
  sharedEm_no = sharedElmodel_no; //  By Abhishek on 23-Jan for elementModel yellow traingle
  // setTimeout(() => {
  for (let i = 0; i < sharedElmodel.length; i += 1) {
    // // isElementAccess =  myUniqElementModels_num.includes(sharedElmodel_no[i]);
    // isElementAccess = myUniqElementModels ? myUniqElementModels.includes(sharedElmodel[i]) : true; // || myUniqElementModels_num.includes(sharedElmodel_no[i])
    if (myUniqElementModels) {
      // isElementAccess = myUniqElementModels_num.includes(sharedElmodel_no[i]);
      isElementAccess = myUniqElementModels.includes(sharedElmodel[i]); // old
      isElementAccess = myUniqElementModels.includes(sharedElmodel[i]) || myUniqElementModels_num.includes(sharedElmodel_no[i]);
      if (isElementAccess === false)
        break;
    }
  }
  return isElementAccess;
};

export const ro_elm_shared_access_stageZero = (formData_ro_temp) => {
  const ro_data_temp = {
    ro: formData_ro_temp
  };
  const ro_pass = Object.values(ro_data_temp.ro);
  /* eslint-disable */
  // todo-: 1st find element model by name then by its id
  const updated_shared_ro = ro_pass.map(item => {
    if (item['grid-data']) {
      const cur_ro = Object.values(item['grid-data'].map(o => {
        const currElMOdel = processInput([o.elementModel]);
        if (myUniqElementModels.indexOf(currElMOdel[0]) >= 0) {  // find the curr. em in the array(all my em access)
          // if (myUniqElementModels.includes(o.elementModel)) {  // here i need to check based on name of elemodel
          o.elementModel = elementModelDirectory[currElMOdel].elementModelName;
          return o;
        } // eslint-disable-next-line
        else {

          if (myUniqElementModels_num.includes(o.elementModelNumber)) {  // here i need to check based on id of elemodel
            return o;
          }
          else {
            o.pressureVessels = 0;
            o.elementsperVessel = 0;
            o.application = '';
            o.elementGroup = '';
            o.elementModel = '';
            o.elementAge = 0.00;
            o.fluxAnnual = 0.00;
            o.saltPassageAnnual = 0.00;
            o.permeatePressure = 0.00;
            o.interStageBoostPressure = 0.00;
            o.boostEnergyEfficiency = 0.00;
            o.interStagePressureLoss = 0.00;

            return o;
          }
        }
      }));
      return cur_ro;
    }
  });
  for (let i = 0; i < ro_pass.length; i += 1) {
    ro_pass[i]['grid-data'] = updated_shared_ro[i];
  }
  const no_of_ro = Object.keys(ro_data_temp.ro);

  for (let i = 0; i < no_of_ro.length; i += 1) {
    ro_data_temp.ro[no_of_ro[i]]['grid-data'] = ro_pass[i]['grid-data'];
  }

  localStorage.setItem('ro-dict-temp', JSON.stringify(ro_data_temp));

  // return ro_data_temp;

};

export const clro_elm_shared_access_stageZero = (formData_ro_temp) => {
  const ro_data_temp = {
    ro: formData_ro_temp
  };
  const ro_pass = Object.values(ro_data_temp.ro);
  /* eslint-disable */
  // todo-: 1st find element model by name then by its id
  const updated_shared_ro = ro_pass.map(item => {
    if (item['grid-data']) {
      const cur_ro = Object.values(item['grid-data'].map(o => {
        const currElMOdel = processInput([o.elementModel]);
        if (myUniqElementModels.indexOf(currElMOdel[0]) >= 0) {  // find the curr. em in the array(all my em access)
          // if (myUniqElementModels.includes(o.elementModel)) {  // here i need to check based on name of elemodel
          o.elementModel = elementModelDirectory[currElMOdel].elementModelName;
          return o;
        } // eslint-disable-next-line
        else {

          if (myUniqElementModels_num.includes(o.elementModelNumber)) {  // here i need to check based on id of elemodel
            return o;
          }
          else {
            o.pressureVessels = 0;
            o.elementsperVessel = 0;
            o.spacersperVessel = 0;
            o.application = '';
            o.elementGroup = '';
            o.elementModel = '';
            o.elementAge = 0.00;
            o.fluxAnnual = 0.00;
            o.saltPassageAnnual = 0.00;
            o.permeatePressure = 0.00;
            o.interStageBoostPressure = 0.00;
            o.boostEnergyEfficiency = 0.00;
            o.interStagePressureLoss = 0.00;

            return o;
          }
        }
      }));
      return cur_ro;
    }
  });
  for (let i = 0; i < ro_pass.length; i += 1) {
    ro_pass[i]['grid-data'] = updated_shared_ro[i];
  }
  const no_of_ro = Object.keys(ro_data_temp.ro);

  for (let i = 0; i < no_of_ro.length; i += 1) {
    ro_data_temp.ro[no_of_ro[i]]['grid-data'] = ro_pass[i]['grid-data'];
  }

  localStorage.setItem('clro-dict-temp', JSON.stringify(ro_data_temp));

  // return ro_data_temp;

};